import { NgZone, OnInit } from '@angular/core';
import { merge, fromEvent } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { Router } from '@angular/router';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath } from '@app/shared/utils';
import { normalizePathFromBreadcrumb } from '../../shared/utils';
var FullMenuSubOptionComponent = /** @class */ (function () {
    function FullMenuSubOptionComponent(authService, _window, router, itauUserIdleService, sessionService, ngZone, featureToggleService, _sdkAnalyticsService) {
        this.authService = authService;
        this._window = _window;
        this.router = router;
        this.itauUserIdleService = itauUserIdleService;
        this.sessionService = sessionService;
        this.ngZone = ngZone;
        this.featureToggleService = featureToggleService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
    }
    FullMenuSubOptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    };
    FullMenuSubOptionComponent.prototype.getMenuURL = function (menuURL) {
        if (menuURL == undefined || menuURL == "")
            return "#";
        return menuURL;
    };
    FullMenuSubOptionComponent.prototype.openModal = function (codFunction, name, typeMenu, url, path) {
        if (path && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(path)
            });
        }
        if (/IS\/#/.test(url)) {
            this.router.navigate(["" + url.split('/#')[1]]);
            return false;
        }
        if (typeMenu != 5) {
            var sUrl = this.authUser.serverEstatisticas + "?xyz=0";
            try {
                this.itauUserIdleService.stopWatching();
                this.sessionService.updateSession().subscribe(function () { });
                var userType = this.authUser.tipo == 1 ? "A" : "C";
                sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
                sUrl += this.getQueryStringFunction(codFunction);
                var windowOK4 = this._window.open(sUrl, name, "directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5");
                this._sdkAnalyticsService.trackEvent('screen_view', {
                    custom_path: normalizePathFromBreadcrumb(path, { prefix: '/iss/lg/' }),
                    implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                    detail: detailFromBreadcrumb(path)
                });
                this.itauUserIdleService.setCustomActivityEvents(merge(fromEvent(window, "mousemove"), fromEvent(window, "resize"), fromEvent(document, "keydown"), fromEvent(document, "touchstart"), fromEvent(document, "touchend"), fromEvent(windowOK4, "mousemove"), fromEvent(windowOK4, "resize")));
                this.itauUserIdleService.startWatching();
            }
            catch (ex) {
                throw ex;
            }
        }
        else {
            this.openModalContext(url);
        }
    };
    FullMenuSubOptionComponent.prototype.openModalContext = function (route) {
        this.setTimeoutNavigation(route, 3);
    };
    FullMenuSubOptionComponent.prototype.setTimeoutNavigation = function (route, retries) {
        var _this = this;
        var attempts = 0;
        var intervalId = setInterval(function () {
            _this.router.navigate([route]).then(function (success) {
                if (success) {
                    clearInterval(intervalId);
                }
                else {
                    attempts++;
                    if (attempts >= retries) {
                        clearInterval(intervalId);
                    }
                }
            }).catch(function (error) {
                attempts++;
                if (attempts >= retries) {
                    console.log(error);
                    clearInterval(intervalId);
                }
            });
        }, 500);
    };
    FullMenuSubOptionComponent.prototype.getQueryStringFunction = function (codFunction) {
        try {
            return "&iDFuncao=" + -1 * codFunction;
        }
        catch (ex) {
            throw ex;
        }
    };
    FullMenuSubOptionComponent.prototype.getQueryString = function (token, idConnection, idSession, sGestor, nameUser, userType) {
        try {
            return ("&sessao=" +
                token +
                "&id=" +
                idConnection +
                "&idsessao=" +
                idSession +
                "&gestor=" +
                sGestor +
                "&nomeUsu=" +
                nameUser +
                "&tipousu=" +
                userType);
        }
        catch (ex) {
            throw ex;
        }
    };
    FullMenuSubOptionComponent.prototype.goToiServices = function (url) {
        if (this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: 'menu-iservices'
            });
        }
        this.featureToggleService.goToiServices(url);
    };
    FullMenuSubOptionComponent.prototype.submitEvent = function (namePage) {
    };
    return FullMenuSubOptionComponent;
}());
export { FullMenuSubOptionComponent };
